import { InlineCalendar } from "PFComponents/calendar/inline_calendar";
import { RefObject } from "react";

import { useCommonProps } from "../use_common_props";

type CalendarCustomValueFieldProps = {
  commonProps: ReturnType<typeof useCommonProps>;
  selectedDate: string | null;
  onChange: (date: string) => void;
  portalRef?: RefObject<HTMLElement | null>;
  letClear?: boolean;
  inputRef?: RefObject<any>;
  inputClassName?: string;
};

export const CalendarCustomValueField = ({
  commonProps,
  selectedDate,
  onChange,
  portalRef,
  letClear,
  inputRef,
  inputClassName
}: CalendarCustomValueFieldProps) => (
  <InlineCalendar
    {...commonProps}
    selectedDate={selectedDate}
    handleChange={onChange}
    portalRef={portalRef}
    letClear={letClear}
    inputRef={inputRef}
    inputClassName={inputClassName}
  />
);
